import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IBranchMastDropdown, ICompanyMastDropdown, IUsersDropdown } from "../../models/IDropdown";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { Fetch } from "../../shared/Fetch";
import { ILogin } from "../../models/Login";

interface IProps {
    open?: boolean,
    singleData?: any,
    hideDialog: () => void,
    toast: any
}
interface ISales {
    company?: number | null,
    user_ID?: number | null,
    user_Name?: string | null,
    branch?: number | null,
    req_PostedBySalesManager?: number | null
}
export const EmptyForm: ISales = {
    company: null,
    branch: null,
    req_PostedBySalesManager: null


}

const schema = yup.object({
    salesManager: yup.array(),
});

export const Share = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [selectedSales1, setSelectedSales1] = useState<Array<IUsersDropdown>>([]);
    const [selectedSales2, setSelectedSales2] = useState<Array<IUsersDropdown>>([]);
    const [selectedSales3, setSelectedSales3] = useState<Array<IUsersDropdown>>([]);
    const [selectedSales4, setSelectedSales4] = useState<Array<IUsersDropdown>>([]);
    const [tek, setTek] = useState<Array<ISales>>();
    const [vyze, setVyze] = useState<Array<ISales>>();
    const [gvr, setGvr] = useState<Array<ISales>>();
    const [adventa, setAdventa] = useState<Array<ISales>>();
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    const loadAllCompanySales = async () => {
        const response = await Fetch("NonPerformingVendor/getSalesList", "GET", null, null, null);
        if (response) {
            const data: any = await response.json();
            setTek(data.tek);
            setVyze(data.vyze);
            setGvr(data.gvr);
            setAdventa(data.adventa);
        }
    };

    const saveToDB = async (data: ISales[]) => {
        setLoading(true);
        const body = {
            vendorCompany: props.singleData.vendor_Company_ID,
            sales: data.map((e) => e.user_ID).join(",")
        }
        if (body.sales === "" || body.sales === "0") {
            props.toast.current.show({ severity: 'error', detail: "Select a Sales Manager", life: 3000 });
            setLoading(false);
        } else {
            const response = await Fetch("NonPerformingVendor", "POST", body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: "Allocated to Sales Manager", life: 3000 });
                setLoading(false);
                onHide();
            } else {
                setLoading(false);
            }
        }
    }

    const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSales(data);
        }
    }


    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        let endPoint = "reqBranchList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        let endPoint = "reqCompanyList";

        const response = await Fetch(`Dropdown/${endPoint}`, "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }

    const onSubmit = (data: ISales) => {
        data.user_ID = data.req_PostedBySalesManager;
        // saveToDB([...selectedSales1,...selectedSales2,...selectedSales3,...selectedSales4]);
        saveToDB([data]);
        console.log([data]);

    }
    const onHide = () => {

        // setSelectedSales1([]);
        // setSelectedSales2([]);
        // setSelectedSales3([]);
        // setSelectedSales4([]);
        reset(EmptyForm)
        props.hideDialog();
    };

    // useEffect(()=>{
    //     if(props.open) loadAllCompanySales();
    // },[props.open]);

    useEffect(() => {
        loadSales(0, 0, 0);
        loadCompanies();
        loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company") {
                if (value.company != 0) {
                    loadBranches(value.company);
                    loadSales(0, value.company, 0);
                } else {
                    loadBranches(); loadSales(0, value.company, 0);
                }
            }

            if (name === "branch") {
                if (value.branch != 0) {
                    loadSales(value.branch, 0, 0);

                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);


    useEffect(() => {
        if (control._formValues.company === 0 && control._formValues.branch === 0 && control._formValues.team === 0) {
            // loginObj.id === 1 ? loadSales(0,0,0) : setSales([]);
            loadSales(0, 0, 0);
        }
        if (control._formValues.company != 0 && control._formValues.branch != 0 && control._formValues.team === 0) {
            loadSales(control._formValues.branch, 0, 0);
        }
        if (control._formValues.company != 0 && control._formValues.branch === 0 && control._formValues.team != 0) {
            loadSales(0, 0, control._formValues.team);
        }
        if (control._formValues.company === 0 && control._formValues.branch != 0 && control._formValues.team != 0) {
            // loadSales(control._formValues.branch,0,0);
            loadSales(0, 0, control._formValues.team);
        }
    }, [control._formValues.company, control._formValues.branch, control._formValues.team]);


    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header={`Allocate ${props.singleData.vendor_Company_Name} to`} className="p-fluid" onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    {/* <JVMultiselect column={4} label="Allocate From Tek" options={tek} optionLabel="user_Name" placeholder="Select Sales" required value={selectedSales1} onChange={setSelectedSales1} />
                    <JVMultiselect column={4} label="Allocate From Vyz" options={vyze} optionLabel="user_Name" placeholder="Select Sales" required value={selectedSales2} onChange={setSelectedSales2} />
                    <JVMultiselect column={4} label="Allocate From GVR" options={gvr} optionLabel="user_Name" placeholder="Select Sales" required value={selectedSales3} onChange={setSelectedSales3} />
                     <JVMultiselect column={4} label="Allocate From Adventa" options={adventa} optionLabel="user_Name" placeholder="Select Sales" required value={selectedSales4} onChange={setSelectedSales4} /> */}
                    <JVDropdown column={3} label="Company" control={control} name="company" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />
                    <JVDropdown column={3} label="Branch" control={control} name="branch" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />
                    <JVDropdown column={3} label="Sales Manager" control={control} name="req_PostedBySalesManager" options={sales} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" />

                    <div className="field col-12 md:col-12">
                        <Button loading={loading} label="ALLOCATE" type="submit"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
}